import { useState } from 'react';

export const useToggle = (defaultValue = false) => {
  const [state, setState] = useState(defaultValue);

  const toggle = () => {
    setState((prev) => !prev);
  };

  const on = () => {
    setState(true);
  };

  const off = () => {
    setState(false);
  };

  return { state, toggle, on, off };
};
